var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarCrossed = function SvgStarCrossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.144 8.74a1 1 0 0 1 .554 1.705l-4.624 4.503 1.092 6.362a1 1 0 0 1-1.451 1.054L12 19.358l-5.715 3.006a1 1 0 0 1-1.451-1.054l.365-2.131L17.918 8.12zM12 1.458a1 1 0 0 1 .896.558l2.412 4.887-9.406 8.178.024-.134-4.623-4.503a1 1 0 0 1 .552-1.706l6.39-.933 2.858-5.79A1 1 0 0 1 12 1.46"
  })));
};
export default SvgStarCrossed;